import { Outlet } from 'react-router-dom';

import { AdminNav } from './AdminNav';

/**
 * The frame every admin page sits in.
 *
 * ## Why it is a layout route rather than a component each page renders
 *
 * All six pages used to render `<AdminNav />` themselves inside their own
 * `mx-auto max-w-4xl` or `max-w-5xl` wrapper - six copies of the chrome, and
 * two different measures depending on which page you were on. Moving it here
 * makes the width one decision instead of six, and means a new admin page gets
 * the navigation by existing rather than by remembering.
 *
 * ## A rail and a workbench
 *
 * The public pages are measured for reading - a column of prose and a column
 * of tracks. This is a workbench: tables of users, queues of reports, a
 * dashboard of charts. So it is the whole width, with the sections down a
 * rail on the left the way every admin panel people already know is laid
 * out, and the page on the right. The rail sticks under the site header and
 * stops above the dock, so it is there wherever a long table has scrolled
 * to.
 *
 * On a narrow window the rail becomes a strip across the top: a rail would
 * take the width the tables need.
 */
export function AdminLayout() {
  return (
    <div className="flex w-full flex-1" data-admin-layout>
      <aside
        className="sticky top-16 hidden h-[calc(100vh-4rem-var(--spacing-dock))] w-56 shrink-0 self-start border-r border-line bg-deep/40 lg:block"
      >
        <AdminNav shape="rail" />
      </aside>

      <div className="min-w-0 flex-1 px-4 py-5 sm:px-6 lg:px-8 lg:py-7">
        <div className="lg:hidden">
          <AdminNav shape="strip" />
        </div>
        <div className="mx-auto flex w-full max-w-[1600px] flex-col gap-5">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
